/*
    Description: research homepage/frontpage cards class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/
// research cards
class Cards{

    // constructor
    constructor({
        wrapper = ".research__block__cards",
        card = ".card",
        leftButton = ".--research-bttn-left",
        rightButton = ".--research-bttn-right"
    } = {}){
    
        // get wrapper
        this.wrapper = (wrapper) ? document.querySelector(wrapper) : null; 
        
        // get individual card
        this.card = (this.wrapper) ? this.wrapper.querySelector(card) : null;

        // get all cards in array
        this.allCards = (this.wrapper && card) ? this.wrapper.querySelectorAll(card) : null;

        // get card total
        this.totalCards = (this.allCards) ? this.allCards.length : 0;
        
        // left and right bttn
        this.rightBttn = (leftButton) ? document.querySelector(rightButton) : null;
        this.leftBttn = (rightButton) ? document.querySelector(leftButton) : null;

        // init wrapper width
        this.wrapperWidth = 0;

        // card style
        this.cardStyle = null; 

        // card margin
        this.cardRightMargin = null;

        // init card slide limit
        this.cardSlideLimit = 0;

        // init how many cards to slide over per click 
        this.cardsPerClick = 1;

        // init offset
        this.offset = 0;

        // init events method
        this.events();

    }

    // events method
    events(){

        // init cardsPerClick calculation
        this.visibleCards();

        // run init method 
        this.init();

        // update init values
        window.addEventListener("resize", this.init.bind(this));

        // left event click
        if(this.leftBttn) this.leftBttn.addEventListener("click", this.left.bind(this));

        //right event click
        if(this.rightBttn) this.rightBttn.addEventListener("click", this.right.bind(this));

    }

    // init method
    init(){

        // reset all card positions
        this.reset();

        // card style
        if(this.card) this.cardStyle = this.card.currentStyle || window.getComputedStyle(this.card); 

        // card margin
        if(this.cardStyle) this.cardRightMargin = Number(this.cardStyle.marginRight.match(/\d+/g)[0]);
        
    }

    // left click
    left(e){
        
        // recalculate cardsPerClick
        this.visibleCards();

        // prevent default
        e.preventDefault();

        // check zero offset
        if(this.offset < 0){
            
            // increment offset
            this.offset += ((this.card.offsetWidth + this.cardRightMargin) * this.cardsPerClick);

            // make sure we dont go past 0
            this.offset = (this.offset > 0) ? 0 : this.offset;

            // all cards
            this.allCards.forEach((card) => {

                // set card position
                card.style.left = `${this.offset}px`;

            });

        }

    }

    // right click event listener
    right(e){

        // recalculate cardsPerClick
        this.visibleCards();

        // prevent default
        e.preventDefault();

        // wrapper width
        if(this.wrapper) this.wrapperWidth = this.wrapper.offsetWidth;

        // wrapper limit
        this.cardSlideLimit = -((this.card.offsetWidth + this.cardRightMargin) * this.totalCards) + this.wrapperWidth;

        // make sure we are not outside the wrapper limit
        if(this.offset > this.cardSlideLimit){

            //  drecrement offset 
            this.offset -= ((this.card.offsetWidth + this.cardRightMargin) * this.cardsPerClick);

            // make sure we are not going to the slide right most limit
            this.offset = (this.offset < this.cardSlideLimit) ? this.cardSlideLimit : this.offset;

            // all cards
            this.allCards.forEach((card) => {

                // set card position
                card.style.left = `${this.offset}px`;

            });
            
        }

    }

    // set how many cards slide per click based on available space
    visibleCards(){

        // make sure we have our wrapper
        if(!this.wrapper || !this.card) return;

        // wrapper width
        const wrapperWidth = this.wrapper.offsetWidth;

        // get card width
        const cardWidth = (this.card.offsetWidth + this.cardRightMargin),
            
        // set card slide count
        cardSlide = Math.floor(wrapperWidth/cardWidth);

        // set cards per click min and max
        this.cardsPerClick = (cardSlide < 1) ? 1 : (cardSlide > this.totalCards) ? this.totalCards : cardSlide;

    }

    // reset cards method (on resize)
    reset(){

        // make sure we have our wrapper
        if(!this.allCards) return;

        // LOOP: run thru all cards
        this.allCards.forEach((card) => {

            // set card position
            card.style.left = "0px";

        });

        // reset offset
        this.offset = 0;

    }

}

// export cards
export default Cards;